import React from 'react';
import PageLayout from '../../layout/PageLayout';
import CounterpartyContent from '../../layout/CounterpartyContent';

interface IProps {
  slug: string;
}

const CounterpartyPage: React.FC<IProps> = ({ slug }: IProps) => (
  <PageLayout>
    <CounterpartyContent slug={slug} />
  </PageLayout>
);

export default CounterpartyPage;
